<template>
  <div class="insert-page" :class="{ step1: stepCount===1, step2: stepCount===2, step3: stepCount===3}">
    <div class="top-line">
      <button type="button" class="btn-close"
            @click="onCloseLayer(false)">
      <i class="icon icon--close-btn"></i>
      </button>
    </div>
    <div class="page-wrap">
      <div class="content-wrap">
        <!-- <div class="header-block">
          <div class="insert-subject">
            {{ $t('heatmap.registration.subject') }}
          </div>
          <div class="url" ref="urlBox">
            {{ pageData.listUrl }}
          </div>
        </div> -->
        <div class="body-wrap">
          <heatmap-registration-step1 v-if="stepCount === 1"
            :model="getModel"
            :originModel="pageData.baApply"
            :pvData="pvData"
            :isEditMode="isEditMode"
            :timezone="timezone"
            :timezoneName="timezoneName"
            :jamCount="baApplyBasketCount"
            :remainJam="totalRemainJam"
            :listUrl="pageData.listUrl"
            :url="pageData.url"
            @codeCheck="onCodeCheck"
            @nextStep="nextStep"
            @register="register"
            @cancelSchedule="cancelSchedule"
            @isShiftJam="isShiftJamEmit"/>
          <heatmap-registration-step2 v-if="stepCount === 2"
            :originUrl="pageData.url"
            :gUrlId="pageData.gUrlId"
            :model="model"
            :isEditMode="isEditMode"
            :listUrl="pageData.listUrl"
            :url="pageData.url"
            @codeCheck="onCodeCheck"
            @nextStep="nextStep"
            @backStep="backStep"
            @register="register"/>
          <heatmap-registration-step3 v-if="stepCount === 3"
            :model="model"
            :listUrl="pageData.listUrl"
            :url="pageData.url"
            :isEditMode="isEditMode"
            @codeCheck="onCodeCheck"
            @backStep="backStep"
            @register="register"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeatmapRegistrationStep1 from './HeatmapRegistrationStep1.vue'
import HeatmapRegistrationStep2 from './HeatmapRegistrationStep2.vue'
import HeatmapRegistrationStep3 from './HeatmapRegistrationStep3.vue'
import { DEFAULT_TIMEZONE, DEFAULT_TIMEZONE_NAME, DATE_FORAMT, HEATMAP_STATE } from '@/libs/constants'
import { createBaApply, updateBaApply, deleteBaApply } from '@/api/heatmap'
import { format } from 'date-fns'
import { getBaBasket, getRemainJam } from '@/api/jam'
import { getPastPvCount } from '@/api/ranking'
import { mapState } from 'vuex'
import store from '@/store'
import { utcToLocalTimezone } from '@/libs/utils'
import { isInIframe } from '@/libs/auth-helper'

export default {
  name: 'HeatmapRegistration',
  components: {
    HeatmapRegistrationStep1,
    HeatmapRegistrationStep2,
    HeatmapRegistrationStep3
  },
  props: {
    pageData: {
      default: {}
    },
    isEditMode: {
      default: false
    },
    timezone: {
      default: DEFAULT_TIMEZONE
    },
    timezoneName: {
      default: DEFAULT_TIMEZONE_NAME
    }
  },
  created () {
    this.baJamCount()
    this.setRemainJam()
    this.getPvCount()
  },
  computed: {
    ...mapState([
      'journeyOptions',
      'baApplyBasketCount',
      'totalRemainJam',
      'userData'
    ]),
    getModel () {
      let model = {
        exceptionSelector: ''
      }
      if (this.pageData.baApply) {
        model = {
          id: this.pageData.baApply._id,
          parentSid: this.pageData.baApply.parentSid,
          exceptionSelector: this.pageData.baApply.exceptionSelector,
          sid: this.pageData.baApply.sid,
          captureURL: this.pageData.baApply.captureURL,
          pathname: this.pageData.baApply.pathname,
          bLogin: this.pageData.baApply.bLogin,
          startDate: this.pageData.baApply.startDate,
          endDate: this.pageData.baApply.endDate
        }
      }
      return model
    }
  },
  data () {
    return {
      stepCount: 1,
      model: {},
      remainJam: 0,
      baJam: 0,
      pvData: {}
    }
  },
  methods: {
    onCodeCheck (url) {
      const isExistUrlParameter = url.indexOf('?') > -1
      window.CodeCheck = window.open(url + (isExistUrlParameter ? '&' : '?') + '_beusable_type=_beusable_code_check' + `&_beusable_lang=${this.$i18n.locale}`, isInIframe() ? '_self' : '_blank')
    },
    isShiftJamEmit (jamCount, totalRemainJam) {
      this.$emit('isShiftJam', jamCount, totalRemainJam)
    },
    baJamCount () {
      const param = {}
      getBaBasket(param, true).then((resp) => {
        store.commit('setBaApplyBasketCount', resp.jamCount)
      })
    },
    setRemainJam () {
      const payload = {}
      getRemainJam(payload, true).then(res => {
        store.commit('setTotalRemainJam', res.paidCount + res.freeCount)
      }).catch(err => {
        console.log(err)
      })
    },
    getPvCount () {
      const isExact = this.journeyOptions.matchType === 'exact'
      const payload = {
        sid: this.journeyOptions.sid,
        matchType: this.journeyOptions.matchType,
        nodeKey: isExact ? this.pageData.url : this.pageData.gUrlId
      }
      getPastPvCount(payload, true).then(resp => {
        this.pvData = resp
      })
    },
    onCloseLayer (register = false) {
      this.$emit('onCloseLayer', register)
    },
    nextStep (data) {
      this.model = data
      if (this.stepCount < 3) {
        this.stepCount += 1
      }
    },
    backStep () {
      if (this.stepCount > 1) {
        this.stepCount -= 1
      }
    },
    cancelSchedule () {
      const data = {
        id: this.pageData.baApply._id
      }
      if (this.pageData.baApply.installDate) {
        data.startDate = null
        data.endDate = null
        data.state = HEATMAP_STATE.ENDBYANALYSISDATE
        updateBaApply(data, true).then((resp) => {
          this.onCloseLayer(true)
        })
      } else {
        deleteBaApply(data).then((resp) => {
          this.onCloseLayer(true)
        })
      }
    },
    register (data) {
      data.gUrlId = this.pageData.gUrlId
      if (data.startDate === null) {
        data.startDate = format(utcToLocalTimezone(new Date(), this.timezoneName), DATE_FORAMT)
      }
      if (this.pageData.baApply) {
        if (this.pageData.baApply.state === 'endByAnalysisDate') {
          data.state = 'error'
        } else if (this.pageData.baApply.state === 'stop') {
          data.state = 'run'
        }
      }
      if (this.isEditMode) {
        updateBaApply(data, true).then((resp) => {
          this.onCloseLayer(true)
        })
      } else {
        data.parentSid = this.journeyOptions.sid
        data.url = this.pageData.url
        createBaApply(data, true).then((resp) => {
          this.onCloseLayer(true)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.insert-page {
  text-align: center;
  position: absolute;
  display: inline-block;
  width: 640px;
  height: 531px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  z-index: 50 !important;
  &.step2 {
    height: 580px;
  }
  &.step3 {
    height: 673px;
  }

  .top-line {
    display: flex;
    justify-content: space-between;

    .btn-close {
      position: absolute;
      right: 12px;
      top: 12px;
    }
  }
  .page-wrap {
    margin: 30px 30px 25px 30px;
    position: relative;
    height: calc(100% - 55px);

    .content-wrap {
      height: 100%;

      .body-wrap {
        height: 100%;
      }
    }
  }
}
</style>
